export default __webpack_public_path__ + "static/media/white-card.50aa3011.svg";